export default "__VITE_ASSET__Bu0WCYlQ__"